<template>
    <div class="attribute-option-list-wrapper form-group row mt-0 mb-4 p-0">
        <label class="col-md-1 col-form-label text-right">&nbsp;</label>
        <div class="col-md-11">
            <table class="attribute-option-table ml-3">

                <tr v-if="attributeOptions.length > 0" class="attribute-option-row-wrapper attribute-option-row">

                    <th class="attribute-option-column-header order-column pl-1">Order</th>
                    <th class="option-column-header value-column pl-1">Selectable Value Fields</th>

                    <th class="attribute-option-column-header delete-column">&nbsp;</th>
                </tr>

                <attribute-option-list-row
                    v-for="option in attributeOptions"
                    :key="option.id"
                    :attribute-option-data="option"
                    :version-id="version"
                    v-on="$listeners"
                    @refresh-options="handleRefresh">
                </attribute-option-list-row>



                <tr class="attribute-option-row-wrapper attribute-option-row pt-2">
                    <td class="list-controls" rowspan="2">

                        <search class="search-override-styles" placeholder="Search/Filter Attribute Options"></search>

                        <pagination
                            class="pagination-override-styles"
                            v-show="showPagination"
                            :pagination="paginationData"
                            @paginate="handlePagination">
                        </pagination>

                    </td>
                    <!-- Delete Row -->
                    <td class="delete-column">&nbsp;</td>
                </tr>

                <tr class="attribute-option-row-wrapper attribute-option-row pt-2">
                    <th v-if="version == '0'" rowspan="2" class="option-column-header value-column pl-1">Add New Value Field</th>
                    <th v-else rowspan="2" class="option-column-header value-column pl-1">You can only create fields in the "Master" version.</th>
                    <th class="attribute-option-column-header delete-column">&nbsp;</th>
                </tr>

                <!-- add new value -->
                <tr class="attribute-option-list-row-wrapper attribute-option-row">
                    <!-- New Value -->
                    <td class="value-column" rowspan="2">
                        <edit-in-place  type="short-text"
                                        class="edit-in-place-cell"
                                        property-value=""
                                        :is-master="version == '0'"
                                        :readOnly="version != '0'">
                            <api-handler change-type="add-new-value" :attribute-id="attributeId" :version-id="version" @success="handleRefreshLastPage" v-on="$listeners"></api-handler>
                        </edit-in-place>
                    </td>
                    <!-- Delete Row -->
                    <td class="delete-column">&nbsp;</td>
                </tr>
            </table>
            <!-- <div class="text-field-wrapper attribute-option-row pt-2 pb-2">
            <input class="text-field-input value-column new-value-input pr-2" placeholder="New Selectable Value" type="text" v-model="newValue">
            <button class="btn btn-primary" :disabled="createDisabled" @click="createNewValueOption(true)">ADD</button>
            </div> -->
        </div>
    </div>
</template>

<script>
import EditInPlace from '../edit-in-place/edit-in-place.vue';
import AttributesOptionApiHandler from './attributes-option-api-handler.vue';
import attributeOptionListRow from './attribute-option-list-row.vue';
import Pagination from '../generic/tables/pagination.vue';
import Search from '../generic/tables/search.vue';

export default {
    name: 'attribute-option-list',
    components: {
        'attribute-option-list-row': attributeOptionListRow,
        'edit-in-place': EditInPlace,
        'api-handler': AttributesOptionApiHandler,
        'pagination': Pagination,
        'search': Search,
    },
    props: {
        attributeOptions: Array,
        attributeOptionsMeta: Object,
        attributeId: String,
        version: String,
    },
    computed: {
        showPagination() {
            if (this.attributeOptionsMeta.hasOwnProperty('last_page')) {
                return this.attributeOptionsMeta.last_page > 1;
            }
            return false;
        },
        paginationData() {
            if (this.attributeOptionsMeta.hasOwnProperty('last_page')) {
                return this.attributeOptionsMeta;
            }
            return {};
        },
    },
    methods: {
        handleRefresh() {
            this.$emit('reloadAttributeOptions', false);
        },
        handleRefreshLastPage() {
            this.$emit('reloadAttributeOptions', true);
        },
        handlePagination() {
            this.$emit('reloadAttributeOptions', false);
        }
    },
}
</script>

<style>
.attribute-option-table {
    width: 100%;
}
.attribute-option-row  {
    display: flex;
}
.order-column {
    max-width: 60px;
    width: 100%;
}

.list-controls {
    width: 100%;
    display: flex;
    justify-content: space-between;

}
.delete-column {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 56px;
}
.attribute-option-column-header {
    text-transform: capitalize;
}
.create-new-title {
    font-weight: bold;
}

.pagination-override-styles {
    padding-right: 4px;
}

.search-override-styles {
    width: 200px
}

</style>